import { render, staticRenderFns } from "./rate-plan-detail.vue?vue&type=template&id=15302082&"
import script from "./rate-plan-detail.vue?vue&type=script&lang=js&"
export * from "./rate-plan-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports